import type { DateValue } from 'components/filter/input/DateRangePicker/types';

/** Default store value for the creation date range — no filter applied */
export function defaultCreationDateRange(): DateValue {
  return {
    range: {
      presetValue: 'no_selection',
      default: true,
    },
  };
}
